import * as React from 'react';
import { useMutation } from '@grandvisionhq/graphql';
import { useCartStorage } from '@grandvisionhq/lib-utils-cart';
import { isNil } from '@grandvisionhq/utils';
import '../operations/fragments/cart-details.js';
import '../operations/fragments/cart-validation-errors.js';
import '../operations/fragments/recover-inactive-cart-failure.js';
import '../operations/fragments/recover-inactive-cart-result.js';
import '../operations/mutations/add-cart-line-items.js';
import '../operations/mutations/add-cart-voucher-codes.js';
import '../operations/mutations/create-cart.js';
import '../operations/mutations/create-cart-from-instant-checkout-link.js';
import '../operations/mutations/create-cart-from-order.js';
import '../operations/mutations/duplicate-cart-line-items.js';
import '../operations/mutations/remove-cart-voucher-codes.js';
import { REMOVE_CART_LINE_ITEMS } from '../operations/mutations/remove-cart-line-items.js';
import '../operations/mutations/update-cart-line-items.js';
import '../operations/mutations/recover-inactive-cart.js';
import '../operations/queries/get-cart.js';
import '../operations/queries/get-total-line-items.js';
import '../operations/queries/get-cart-estimated-delivery.js';

const useRemoveInsuranceFromCart = (onSuccess)=>{
    const [{ cartId  }, { setCartCount  }] = useCartStorage();
    const [removeCartItems, removeCartLineItemsMutation] = useMutation(REMOVE_CART_LINE_ITEMS, {
        onCompleted: (response)=>{
            if ('removeCartLineItems' in response) {
                const { success , cart  } = response.removeCartLineItems;
                success && cart && setCartCount(cart.numberOfItems);
            }
            onSuccess && onSuccess();
        }
    });
    const removeFromCart = React.useCallback((lineItemId)=>{
        if (isNil(cartId)) {
            console.error('No cart ID available');
            return;
        }
        removeCartItems({
            variables: {
                cartInput: {
                    cartId,
                    lineItems: [
                        {
                            id: lineItemId
                        }, 
                    ]
                }
            }
        });
    }, [
        cartId,
        removeCartItems
    ]);
    const { called , loading , error  } = removeCartLineItemsMutation;
    return [
        removeFromCart,
        {
            called,
            loading,
            error
        }
    ];
};

export { useRemoveInsuranceFromCart };
//# sourceMappingURL=use-remove-insurance-from-cart.js.map
